export interface Task {
  type: UtilityTask;
  name: string;
}

export enum UtilityTask {
  BOX_COMPLIANCE_AUDIT = "BOX_COMPLIANCE_AUDIT",
  CUSTOMS_STATUS = "CUSTOMS_STATUS",
  DAMAGED_PACKAGE = "DAMAGED_PACKAGE",
  B2B = "B2B",
  SINGLE_POOL = "SINGLE_POOL",
  MISSING_LABEL_PACKAGE = "MISSING_LABEL_PACKAGE",
  POLYBAG_COMPLIANCE_AUDIT = "POLYBAG_COMPLIANCE_AUDIT",
  RETURNS_PACKAGE = "RETURNS_PACKAGE",
  TRUCK_CLOSEOUT = "TRUCK_CLOSEOUT",
}

export const UtilityTaskNames: Record<UtilityTask, string> = {
  [UtilityTask.BOX_COMPLIANCE_AUDIT]: "Box Compliance Audit",
  [UtilityTask.CUSTOMS_STATUS]: "Section 321 Customs Status",
  [UtilityTask.DAMAGED_PACKAGE]: "Damaged Package",
  [UtilityTask.B2B]: "B2B",
  [UtilityTask.SINGLE_POOL]: "Single Pool",
  [UtilityTask.MISSING_LABEL_PACKAGE]: "Missing Label Package",
  [UtilityTask.POLYBAG_COMPLIANCE_AUDIT]: "Polybag Compliance Audit",
  [UtilityTask.RETURNS_PACKAGE]: "Returns Package",
  [UtilityTask.TRUCK_CLOSEOUT]: "Truck Closeout",
};

export const UtilityTaskList: Task[] = [
  {
    type: UtilityTask.BOX_COMPLIANCE_AUDIT,
    name: UtilityTaskNames.BOX_COMPLIANCE_AUDIT,
  },
  {
    type: UtilityTask.CUSTOMS_STATUS,
    name: UtilityTaskNames.CUSTOMS_STATUS,
  },
  {
    type: UtilityTask.DAMAGED_PACKAGE,
    name: UtilityTaskNames.DAMAGED_PACKAGE,
  },
  {
    type: UtilityTask.B2B,
    name: UtilityTaskNames.B2B,
  },
  {
    type: UtilityTask.SINGLE_POOL,
    name: UtilityTaskNames.SINGLE_POOL,
  },
  {
    type: UtilityTask.MISSING_LABEL_PACKAGE,
    name: UtilityTaskNames.MISSING_LABEL_PACKAGE,
  },
  {
    type: UtilityTask.POLYBAG_COMPLIANCE_AUDIT,
    name: UtilityTaskNames.POLYBAG_COMPLIANCE_AUDIT,
  },

  {
    type: UtilityTask.RETURNS_PACKAGE,
    name: UtilityTaskNames.RETURNS_PACKAGE,
  },
  {
    type: UtilityTask.TRUCK_CLOSEOUT,
    name: UtilityTaskNames.TRUCK_CLOSEOUT,
  },
];
